// Строка-сводка выбранных настроек над полем промпта: одним кликом открывает
// панель настроек. Описывать нечего (моделей нет вовсе) — прячем и полоску:
// пустая кликабельная строка была бы контролом без смысла. Настройки при этом
// остаются доступны кнопкой в тулбаре.

import { Fragment, useMemo } from "react";

import { useChatSettingsStore } from "~/shared/store/useChatSettingsStore";

import { buildSettingsSummary } from "./prompt-cost";

import type { ModelConfig } from "~/shared/data/chat-models";

export interface PromptSettingsSummaryProps {
    model: ModelConfig | undefined;
    onOpenSettings: () => void;
}

export function PromptSettingsSummary({ model, onOpenSettings }: PromptSettingsSummaryProps) {
    const artifactType = useChatSettingsStore((s) => s.artifactType);
    const mode = useChatSettingsStore((s) => s.mode);
    const aspectRatio = useChatSettingsStore((s) => s.aspectRatio);
    const resolution = useChatSettingsStore((s) => s.resolution);
    const duration = useChatSettingsStore((s) => s.duration);
    const batchSize = useChatSettingsStore((s) => s.batchSize);

    const summary = useMemo(
        () =>
            buildSettingsSummary({ model, mode, aspectRatio, resolution, artifactType, duration, batchSize }),
        [model, mode, aspectRatio, resolution, artifactType, duration, batchSize],
    );

    if (summary.length === 0) return null;

    return (
        <button
            type="button"
            onClick={onOpenSettings}
            className="-mx-0.5 mb-1.5 flex w-full items-center gap-0 overflow-hidden rounded-md px-1.5 py-1 text-xs text-zinc-500 transition-colors hover:bg-white/5 hover:text-zinc-300"
        >
            <span className="truncate">
                {summary.map((part, i) => (
                    <Fragment key={`${part}-${i}`}>
                        {i > 0 && <span className="mx-1 text-zinc-700">·</span>}
                        <span className={i === 0 ? "text-zinc-300" : ""}>{part}</span>
                    </Fragment>
                ))}
            </span>
        </button>
    );
}
